const openDialogTrigger = document.getElementById("size-chart-dialog-triger")
const closeDialogTrigger = document.getElementById("size-chart-dialog-close-trigger")
const dialog = document.getElementById("size-chart-dialog")

const closeSizeChartDialog = () => {
    dialog.close();
    document.body.style.removeProperty("overflow");
}

openDialogTrigger.addEventListener("click", () => {
    dialog.showModal();
    dialog.addEventListener("click", (e) => {
        const rect = dialog.getBoundingClientRect();
        const isInDialog = 
            rect.top <= e.clientY
            && e.clientY <= rect.top + rect.height
            && rect.left <= e.clientX
            && e.clientX <= rect.left + rect.width;

        if (!isInDialog) closeSizeChartDialog();
    });
    document.body.style.overflow = "hidden"
});

closeDialogTrigger.addEventListener("click", () => {
    closeSizeChartDialog();
});